// comming this page i want to add the department page and i want to add the department page in the website section of the project.

// src/components/website/ComingSoon.jsx
import React from 'react';
import { 
  AcademicCapIcon,
  EnvelopeIcon,
  PhoneIcon,
  MapPinIcon,
  SparklesIcon
} from '@heroicons/react/24/outline';

const ComingSoon = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-900 via-purple-900 to-blue-900 relative overflow-hidden flex items-center justify-center px-4">
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-10 left-10 w-72 h-72 bg-blue-400 rounded-full animate-pulse"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-purple-400 rounded-full animate-pulse delay-1000"></div>
      </div>

      <div className="relative max-w-4xl mx-auto text-center text-white py-16">
        <div className="mb-8 flex justify-center">
          <div className="w-20 h-20 bg-gradient-to-br from-yellow-400 to-orange-500 rounded-2xl flex items-center justify-center shadow-2xl">
            <AcademicCapIcon className="h-12 w-12 text-white" />
          </div>
        </div>

        <h1 className="text-4xl md:text-6xl font-bold mb-4">
          <span className="bg-gradient-to-r from-yellow-300 via-yellow-400 to-orange-400 bg-clip-text text-transparent">
            Vidya Bharati
          </span>
          <br />
          <span className="text-white text-3xl md:text-4xl">Public School Bhalki</span>
        </h1>

        <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-lg rounded-full px-6 py-2 mb-8 border border-white/20">
          <SparklesIcon className="h-4 w-4 text-yellow-300" />
          <span className="text-sm font-medium">Website Under Construction</span>
        </div>

        <h2 className="text-6xl md:text-8xl font-bold mb-6 leading-tight">
          <span className="text-white">Coming</span>{' '}
          <span className="bg-gradient-to-r from-yellow-300 to-orange-400 bg-clip-text text-transparent">Soon</span>
        </h2>

        <p className="text-lg md:text-xl text-blue-200 max-w-2xl mx-auto mb-12">
          We're working hard to bring you an amazing experience. Our new website will be live shortly. Stay tuned!
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 max-w-3xl mx-auto">
          <div className="flex items-center justify-center gap-3 bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/10">
            <MapPinIcon className="h-5 w-5 text-yellow-300" />
            <span className="text-sm">Bhalki, Karnataka</span>
          </div>
          <div className="flex items-center justify-center gap-3 bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/10">
            <PhoneIcon className="h-5 w-5 text-yellow-300" />
            <span className="text-sm">+91 98765 43210</span>
          </div>
          <div className="flex items-center justify-center gap-3 bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/10">
            <EnvelopeIcon className="h-5 w-5 text-yellow-300" />
            <span className="text-sm">info@vbps.edu.in</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;